import React from "react";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import { displayValue, displayBoolean, displayDate, displayNumber } from "helpers/displayFormatters";
import { useRuleValidator } from "hooks/useRuleValidator";
import { PERMISSIONS } from "router/permissions";
import { ReadOnlyField } from "./ReadOnlyField";

const { CRM_EQUIVALENCE_ERP_GN4_CONDITIONS_WHOLE } = PERMISSIONS;

export const CreditConditionsDetails = () => {
  const { creditConditions } = useSelector(({ erpEquivalencies }) => erpEquivalencies);
  const canViewAllConditions = useRuleValidator(CRM_EQUIVALENCE_ERP_GN4_CONDITIONS_WHOLE);
  const {
    billToCode, billToAccount, isCreditNote, discount,
    isCreditSuspended, suspensionDate, availableCredit,
    creditLimit, creditDays, isWholesaler, discountType,
  } = creditConditions;

  const displayedDiscountType = discountType || "PU (Precio Unitario)";

  const fields = [
    { label: "Cuenta GN4 BILL TO (Código ERP)", value: displayValue(billToCode) },
    { label: "Cuenta ERP BILL TO (Código)", value: displayValue(billToAccount) },
    { label: "Nota de crédito", value: displayBoolean(isCreditNote) },
    { label: "Descuento", value: displayValue(discount) },
    { label: "¿Está suspendido?", value: displayBoolean(isCreditSuspended) },
    { label: "Fecha de suspensión", value: displayDate(suspensionDate), visible: isCreditSuspended },
    { label: "Crédito disponible", value: displayNumber(availableCredit), adornment: "$" },
    { label: "Límite de crédito", value: displayNumber(creditLimit), adornment: "$" },
    { label: "Días de crédito", value: displayValue(creditDays) },
    { label: "Tipo de descuento", value: displayedDiscountType },
    { label: "Mayorista", value: displayBoolean(isWholesaler), visible: canViewAllConditions },
  ];

  return (
    <Grid container spacing={1}>
      {fields
        .filter(({ visible }) => visible !== false)
        .map(({ label, value, adornment }) => (
          <ReadOnlyField key={label} label={label} value={value} adornment={adornment} />
        ))}
    </Grid>
  );
};
